import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ACTIONS } from "../../redux/actions";
import { HeadersPath } from "../../Utils/ScreenPath";
import { useNavigate } from "react-router-dom";
import { Api } from "../../Service/api";
import { ErrorToast, SuccessToast } from "../../Common/Toast";
import PaperBox from "../../Component/PaperHistory/PaperBox";
import { path } from "../../Utils/ScreenPath";
import { madeFinalObject } from "../../helper/madeFinalObject";
import { dynamicSequence } from "../../helper/dynamicSequence";
import { NotDataFound } from "../NotFound";

const PaperHistory = ({ }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loader = useSelector((state) => state?.Loader?.Loader);
  const [paperHistory, setPaperHistory] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isFetching, setIsFetching] = useState(false);

  let papers = [
    {
      id: 187018,
      school_name: "Youth",
      standard_name: "10",
      subject_name: "Maths",
      createdAt: "2024-10-23T12:23:53.000Z",
      paper_type: "manually",
      exam_marks: "30",
    },
    {
      id: 174329,
      school_name: "Youth",
      standard_name: "10",
      subject_name: "Maths",
      createdAt: "2024-10-08T12:46:35.000Z",
      paper_type: "manually",
      exam_marks: "10",
    },
  ];

  const _getPaperHistory = async (pageNumber = 1) => {
    if (isFetching || (!hasMore && pageNumber !== 1)) return;

    setIsFetching(true);
    if (pageNumber === 1) {
      dispatch(ACTIONS.startLoading());
    }

    try {
      let params = {
        limit: 50,
        offset: pageNumber,
      };
      const { data } = await Api.paperHistory(params);
      const res = JSON.parse(data);
      if (res?.status === 200) {
        const newData = res?.data || [];
        if (pageNumber === 1) {
          setPaperHistory(newData);
        } else {
          setPaperHistory((prev) => [...prev, ...newData]);
        }

        if (newData.length < 50) {
          setHasMore(false);
        } else {
          setHasMore(true);
        }
      }
    } catch (e) {
      ErrorToast(e);
    } finally {
      setIsFetching(false);
      if (pageNumber === 1) {
        dispatch(ACTIONS.stopLoading());
      }
    }
  };

  const handleEdit = async (data) => {
    const sectionsData = JSON?.parse(JSON?.parse(data?.finalsections_info));

    const sections = sectionsData?.map((item, index) => {
      return {
        ...item,
        section_id: index + 1,
        divisions: item?.divisions?.map((ele, ind) => {
          return {
            ...ele,
            division_id: ind + 1
          }
        })
      };
    });

    const paperData = {
      ...data,
      sections_info: sections,
    };

    let FinalObject = await madeFinalObject(paperData?.sections_info, false);
    let dataObject = await dynamicSequence(FinalObject);
    dispatch(ACTIONS.getSelectedData({ ...data, sections_info: dataObject }));
    if (data?.genrate_type === "with section") {
      dispatch(ACTIONS?.getHeaderPath(HeadersPath?.SectionWise));
      navigate(path?.ManuallyGenerate + `/${true}`);
    } else if (data?.genrate_type === "without section") {
      dispatch(ACTIONS?.getHeaderPath(HeadersPath?.withoutSection));
      navigate(path?.ManuallyGenerate + `/${true}`);
    }
  };

  const handleDelete = async (id) => {
    dispatch(ACTIONS.startLoading());
    try {
      const { data } = await Api.deletePaper(id);
      const res = JSON.parse(data);
      if (res?.status === 200) {
        SuccessToast(res?.message);
        SuccessToast(res?.message);
        setPage(1);
        setHasMore(true);
        _getPaperHistory(1);
      }
    } catch (e) {
      ErrorToast(e);
    } finally {
      dispatch(ACTIONS.stopLoading());
    }
  };

  const handlePreview = async (data) => {
    const paperData = {
      ...data,
      dualPaperView: data?.dualPaperView === 1 || data?.dualPaperView === true || data?.isAccessDualPaper === 1,
      sections_info: JSON.parse(JSON.parse(data?.finalsections_info)),
    };
    let FinalObject = await madeFinalObject(paperData?.sections_info, false);
    let dataObject = await dynamicSequence(FinalObject);
    dispatch(ACTIONS.getSelectedData({ ...data, sections_info: dataObject }));
    navigate(path?.PdfPreview);
  };

  useEffect(() => {
    _getPaperHistory(1);
    dispatch(ACTIONS.getHeaderPath(HeadersPath.PaperHistory));
  }, []);

  useEffect(() => {
    const handleScroll = (e) => {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      if (scrollHeight - scrollTop <= clientHeight + 100) {
        if (!isFetching && hasMore) {
          setPage((prev) => {
            const nextPage = prev + 1;
            _getPaperHistory(nextPage);
            return nextPage;
          });
        }
      }
    };

    const scrollContainer = document.querySelector(".overflow-y-auto");
    if (scrollContainer) {
      scrollContainer.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (scrollContainer) {
        scrollContainer.removeEventListener("scroll", handleScroll);
      }
    };
  }, [isFetching, hasMore]);

  return (
    <>
      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4 py-4">
        {paperHistory.map((paper) => (
          <PaperBox
            key={paper.id}
            paper={paper}
            onEdit={handleEdit}
            onDelete={handleDelete}
            onPreview={handlePreview}
          />
        ))}
      </div>
      {isFetching && (
        <div className="flex justify-center py-4">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#138CE3]"></div>
        </div>
      )}
      {paperHistory.length === 0 &&
        loader === false &&
        !isFetching &&
        NotDataFound("No History Found")}
    </>
  );
};

export default PaperHistory;
